<template>
  <div class="corporationRow" @click="showCorporationList">
    <img class="icon" :src="corporation.image" alt="企業ロゴ" />
    <div class="name">{{ t(corporation.name) }}</div>
    <div class="arrow">〉</div>
    <div class="categories">
      <div class="category" v-for="category in corporation.categories" :key="category.id">
        {{ t(category.category_name) }}
      </div>
    </div>
  </div>
</template>

<script>
import t from '@/plugins/i18n';

export default {
  mixins: [t],

  props: {
    corporation: {
      type: Object,
    },
  },

  methods: {
    showCorporationList() {
      if (this.corporation.pack === false) {
        this.$emit('show-modal'); // 親に通知
      } else {
        this.$router.push(`/store/page/${this.corporation.url}`);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.corporationRow {
  position: relative;
  display: flex;
  align-items: center;
  background-color: #fff;
  border-radius: 30px;
  box-shadow: 0 0 8px rgba(0, 0, 0, 1);
  padding: 16px 20px;
  margin: 20px auto;
  // max-width: 670px;
  width: 90%;
  justify-content: center;
  cursor: pointer;
  transition: transform 0.2s;
  &:hover {
    transform: translateY(-2px);
  }

  .icon {
    position: absolute;
    left: 20px;
    height: 60px;
    width: 60px;
    border-radius: 50%;
    object-fit: cover;
    background-color: #eee;
    @media screen and (max-width: $tabletWidth) {
      height: 50px;
      width: 50px;
    }
  }
  .name {
    font-weight: bold;
    font-size: 30px;
    color: #222;
    text-align: center;
    width: 100%;
    @media screen and (max-width: $tabletWidth) {
      font-size: 18px;
    }
  }
  .arrow{
    text-align: right;
    font-weight: bold;
    font-size: 22px;
  }
  .categories {
    position: absolute;
    top: -17px;
    right: 20px;
    display: flex;
    gap: 5px;
    .category {
      background: linear-gradient(to top, #2a70b8, #2c7abf, #2d9dd9, #70c7d6);
      color: #fff;
      font-size: 20px;
      padding: 4px 20px;
      border-radius: 25px;
      box-shadow: 0 0 8px rgba(0, 0, 0, 0.5);
      white-space: nowrap;
      @media screen and (max-width: $tabletWidth) {
        font-size: 12px;
      }
    }
  }
}

</style>
